import React, { useContext, useEffect, useState } from 'react'
import { convertKeysToLowerCase, hexToRgba, isJsonString } from '../../../../../utils/constants';
import { primaryColor } from '../../../../../utils/colors';
import { Button, Grid } from '@mui/material'
import Carousel from '../../../../../components/utility/globalCarousel/carousel';
import InsuranceCard from '../chatWidgetComponents/insuranceCard';
import RatingCard from '../chatWidgetComponents/ratingCard';
import DropdownTemplate from '../chatWidgetComponents/dropdown';
import { ChatbotContext, ChatbotContextPayload } from '../../../../../context/chatbotContext';
import CustomForm from '../chatWidgetComponents/customForm';
import CartFormGlobal from '../chatWidgetComponents/cartFormGlobal';
import CartCarouselGlobal from '../chatWidgetComponents/cartCarouselGlobal';
import ExtensionDrawer from '../chatWidgetComponents/extensionDrawer';
import AppointmentSchedule from '../chatWidgetComponents/appointmentSchedule';
import { drowerPropsConfig } from '../../../../../models/axiosModel';
import TableFormatGlobal from '../chatWidgetComponents/tableFormatGlobal';
import FAQSectionGlobal from '../chatWidgetComponents/faqSectionGlobal';
import styles from '../../../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss'
import { getThread } from '../../../utils';

function MessageFormatComponents(props: any) {
    const { thread, currentActiveChatbotThread } = props;
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload
    const [drawerProps, setDrawerProps] = useState<drowerPropsConfig>({
        openDrawer: false,
        dropdown_options: [],
        option_key_name: "",
        image_url: null,
        flag_multiple: false,
        dropdown_name: ""
    })

    const getParsedThreadData = (threadValue: string) => {
        try {
            const cleanValue = threadValue.replace("```json", "").replace("```", "");
            if (!isJsonString(cleanValue)) return null;

            const json = JSON.parse(cleanValue);

            if (typeof json !== "object") return null;

            // Check error message
            if (json?.error_message && json.error_message !== "" && json.error_message.toLowerCase() !== "no error found") {
                return null;
            }

            return json;
        } catch (err) {
            return null;
        }
    };

    const getFontColor = (ele: any) => {
        let findData = currentActiveChatbotThread?.chatbot_thread_data?.find((threadData: any) => Number(threadData.chatbot_thread_seq) === (Number(thread.chatbot_thread_seq) + 1))
        if (findData) {
            if (findData?.chatbot_thread_value === ele.suggestion_name) {
                let threadFontColor = currentActiveChatbotThread?.chatbot_theme?.chatbot_header_font_color
                let chatbotFontColor = chatBotDetails?.chatbot_theme?.chatbot_header_font_color

                if (threadFontColor) {
                    return threadFontColor
                }
                return chatbotFontColor
            }
            return ""
        }
        return ""
    }

    const getBackgroundColor = (ele: any) => {
        let findData = currentActiveChatbotThread?.chatbot_thread_data?.find((threadData: any) => Number(threadData.chatbot_thread_seq) === (Number(thread.chatbot_thread_seq) + 1))
        if (findData) {
            if (findData?.chatbot_thread_value === ele.suggestion_name) {
                let threadFontColor = currentActiveChatbotThread?.chatbot_theme?.chatbot_header_color
                let chatbotFontColor = chatBotDetails?.chatbot_theme?.chatbot_header_color

                if (threadFontColor) {
                    return threadFontColor
                }
                return chatbotFontColor
            }
            return ""
        }
        return ""
    }

    const getButtonBackgroundColor = (ele: any) => {
        let findData = currentActiveChatbotThread?.chatbot_thread_data?.find((threadData: any) => Number(threadData.chatbot_thread_seq) === (Number(thread.chatbot_thread_seq) + 1))
        if (findData) {
            let threadFontColor = currentActiveChatbotThread?.chatbot_theme?.chatbot_header_color
            let chatbotFontColor = chatBotDetails?.chatbot_theme?.chatbot_header_color
            if (findData?.chatbot_thread_value === ele.suggestion_name) {
                if (threadFontColor) {
                    return threadFontColor
                }
                return chatbotFontColor
            }
            else {
                if (threadFontColor) {
                    return threadFontColor
                }
                return chatbotFontColor
            }
        }
        return "#FFF !important"
    }

    const getButtonFontColor = (ele: any) => {
        let findData = currentActiveChatbotThread?.chatbot_thread_data?.find((threadData: any) => Number(threadData.chatbot_thread_seq) === (Number(thread.chatbot_thread_seq) + 1))
        if (findData) {
            let threadFontColor = currentActiveChatbotThread?.chatbot_theme?.chatbot_header_font_color
            let chatbotFontColor = chatBotDetails?.chatbot_theme?.chatbot_header_font_color
            if (findData?.chatbot_thread_value === ele.suggestion_name) {
                if (threadFontColor) {
                    return threadFontColor
                }
                return chatbotFontColor
            }
            else {
                if (threadFontColor) {
                    return threadFontColor
                }
                return chatbotFontColor
            }
        }
        return "#000 !important"
    }

    const getButtonBoxShadowColor = (ele: any) => {
        let findData = currentActiveChatbotThread?.chatbot_thread_data?.find((threadData: any) => Number(threadData.chatbot_thread_seq) === (Number(thread.chatbot_thread_seq) + 1))
        if (findData) {
            let threadFontColor = currentActiveChatbotThread?.chatbot_theme?.chatbot_send_message_icon_color
            let chatbotFontColor = chatBotDetails?.chatbot_theme?.chatbot_send_message_icon_color
            if (findData?.chatbot_thread_value === ele.suggestion_name) {
                if (threadFontColor) {
                    return threadFontColor
                }
                return chatbotFontColor
            }
            else {
                if (threadFontColor) {
                    return threadFontColor
                }
                return chatbotFontColor
            }
        }
        return primaryColor
    }

    const renderMessageByFormat = (
        formatId: number,
        data: any,
        thread: any,
        nextThread: any,
        drawerProps: any,
        setDrawerProps: any,
        chatbotTheme: any
    ) => {
        switch (formatId) {
            case 2:
                return (
                    <Grid item xs={12}>
                        <Grid container gap="10px" mt={1} ml={1} justifyContent="end">
                            {data.message_fields?.suggestions?.map((ele: any, i: number) => (
                                <Button 
                                    key={i} 
                                    disableRipple 
                                    className={styles.messageButtonStyles}
                                    sx={{
                                        // borderColor: currentActiveChatbotThread?.chatbot_theme?.chatbot_header_color ? `${currentActiveChatbotThread?.chatbot_theme?.chatbot_header_color} !important` : chatBotDetails?.chatbot_theme.chatbot_header_color ? chatBotDetails?.chatbot_theme.chatbot_header_color : "#000000",
                                        boxShadow: `0px 0px 5px 0px ${hexToRgba(getButtonBoxShadowColor(ele))}`,
                                        backgroundColor: getButtonBackgroundColor(ele),
                                        color: getButtonFontColor(ele),                                      
                                        '&:hover': {
                                            border: "none !important",
                                            color: getFontColor(ele),
                                            backgroundColor: getBackgroundColor(ele)
                                        }
                                    }} 
                                    variant="outlined" 
                                    size="small"
                                >
                                    {ele.suggestion_name}
                                </Button>
                            ))}
                        </Grid>
                    </Grid>
                );

            case 5:
                return (
                    <Grid item xs={12}>
                        <Carousel
                            suggestions={convertKeysToLowerCase(data).message_fields.cards}
                            threadData={convertKeysToLowerCase(data)}
                            chatbotTheme={chatbotTheme}
                            currentActiveChatbotThread={thread}
                        />
                    </Grid>
                );

            case 6:
                return (
                    <Grid item xs={12}>
                        <InsuranceCard data={data} chatbotTheme={chatbotTheme} />
                    </Grid>
                );

            case 7:
                return (
                    <Grid item xs={12}>
                        <RatingCard thread={thread} nextThread={nextThread} data={data} chatbotTheme={chatbotTheme} />
                    </Grid>
                );

            case 8:
                return (
                    <Grid item xs={12} sx={{ boxShadow: "0px 0px 2px rgba(0,0,0,0.25)", borderRadius: "10px" }} mt={1}>
                        <AppointmentSchedule
                            thread={thread}
                            nextThread={nextThread}
                            data={data.message_fields}
                            chatbotTheme={chatbotTheme}
                        />
                    </Grid>
                );

            case 9:
                return (
                    <Grid item xs={12}>
                        <DropdownTemplate
                            thread={thread}
                            nextThread={nextThread}
                            data={data}
                            chatbotTheme={chatbotTheme}
                            drawerProps={drawerProps}
                            setDrawerProps={setDrawerProps}
                        />
                    </Grid>
                );

            case 10:
                return (
                    <Grid item xs={12}>
                        <CartCarouselGlobal
                            data={data}
                            threadId={thread.chatbot_thread_id}
                            thread={thread}
                            chatbotTheme={chatbotTheme}
                        />
                    </Grid>
                );

            case 12:
                return (
                    <Grid item xs={12} lg={9} xl={6}>
                        <CustomForm data={convertKeysToLowerCase(data)} thread={thread} chatbotTheme={chatbotTheme} />
                    </Grid>
                );

            case 15:
                return (
                    <Grid item xs={12}>
                        <CartFormGlobal
                            data={data}
                            thread={thread}
                            cartData={data.message_fields.cards}
                            ctaButtons={data.message_fields.CTA_buttons}
                            threadId={thread.chatbot_thread_id}
                            chatbotTheme={chatbotTheme}
                        />
                    </Grid>
                );

            case 16:
                return (
                    <Grid item xs={12}>
                        <TableFormatGlobal
                            data={data}
                            fields={
                                data.message_format_id == 16.3
                                    ? data.message_fields
                                    : convertKeysToLowerCase(data).message_fields
                            }
                            threadId={thread.chatbot_thread_id}
                            chatbotTheme={chatbotTheme}
                        />
                    </Grid>
                );

            case 17:
                return (
                    <Grid item xs={12}>
                        <ExtensionDrawer
                            thread={thread}
                            threadData={convertKeysToLowerCase(data)}
                            fields={convertKeysToLowerCase(data).message_fields}
                            threadId={thread.chatbot_thread_id}
                            chatbotTheme={chatbotTheme}
                        />
                    </Grid>
                );

            case 18:
                return (
                    <Grid item xs={12}>
                        <FAQSectionGlobal
                            thread={thread}
                            threadData={convertKeysToLowerCase(data)}
                            fields={convertKeysToLowerCase(data).message_fields}
                            threadId={thread.chatbot_thread_id}
                            chatbotTheme={chatbotTheme}
                        />
                    </Grid>
                );

            default:
                return null;
        }
    };

    const parsedData = getParsedThreadData(thread.chatbot_thread_value);
    const nextThread = getThread(thread);

    if (!parsedData) return null;

    const formatId = Math.trunc(parsedData.message_format_id);

    return (
        <>
            {renderMessageByFormat(
                formatId,
                parsedData,
                thread,
                nextThread,
                drawerProps,
                setDrawerProps,
                currentActiveChatbotThread.chatbot_theme
            )}
        </>
    )
}

export default MessageFormatComponents